import React from 'react';
import AppLayout from '../../layout/app.layout';
import PAGE_TITLE_LIST from '../../config/page-title.config';
import ListUserTestimonialVideo from '../../components/content/list-user-testimonial-video.component';

const ContentUserVideoView = () => {
  const pageTitle = `${PAGE_TITLE_LIST.CONTENT_USER_TESTIMONIALS_VIDEO}`;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListUserTestimonialVideo />
    </AppLayout>
  );
};

ContentUserVideoView.propTypes = {};

export default ContentUserVideoView;
